import {IServiceFactory} from "../../../service-factory.interface";
import {CknSsrBase} from "./ckn-ssr-base";


export default class CknSsrType extends CknSsrBase {
    constructor(services: IServiceFactory) {
        super('CKN', services);
    }
}
